import { clientsContactsListOptions, ReturnContactReadable } from '@crm/api'
import { PhoneNumbers } from '@crm/components'
import { ConditionalText, DayLabel, TableContainer } from '@shared/components'
import { useQueryParams } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { getFullName } from '@shared/utils'
import { useQuery } from '@tanstack/react-query'
import { TableColumnsType, Typography } from 'antd'
import { useParams } from 'react-router-dom'

const { Paragraph } = Typography

export const ClientContactsCol = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const params = useQueryParams()

  const { data, isLoading } = useQuery({
    ...clientsContactsListOptions({
      path: { client_id: id! },
      query: { ...params }
    }),
    enabled: !!id
  })

  const columns: TableColumnsType<ReturnContactReadable> = [
    {
      title: t('contacts.full_name'),
      key: 'first_name',
      render: (_, record) => (
        <ConditionalText
          condition={!!record?.first_name || !!record?.last_name}
        >
          {getFullName(record)}
        </ConditionalText>
      )
    },
    {
      title: t('contacts.email'),
      key: 'email',
      render: (_, { email, email_valid }) => (
        <ConditionalText
          condition={!!email}
          type={email_valid ? undefined : 'danger'}
        >
          {email}
        </ConditionalText>
      )
    },
    {
      title: t('contacts.phone_number'),
      key: 'phone_number',
      render: (_, record) => (
        <PhoneNumbers phoneNumbers={record?.phone_numbers} />
      )
    },
    {
      title: t('lead.leads'),
      key: 'lead',
      width: 150,
      render: (_, record) => {
        const leads =
          record.leads
            .map(({ name }) => name ?? t('contacts.lead').toLowerCase())
            .join(', ') || '-'

        return (
          <Paragraph ellipsis={{ rows: 2, tooltip: leads }}>{leads}</Paragraph>
        )
      }
    },
    {
      title: t('lead.created_at'),
      key: 'created_at',
      render: (_, { created_at }) => <DayLabel date={created_at} />
    },
    {
      title: t('lead.modified_at'),
      key: 'modified_at',
      render: (_, { modified_at }) => <DayLabel date={modified_at} />
    }
  ]

  return (
    <TableContainer
      rowKey="id"
      columns={columns}
      data={data}
      loading={isLoading}
    />
  )
}
